<template>
  <bim-checkbox
    :value="value"
    @input="v => $emit('input', v)"
    :label="label"
    :id="id"
  />
</template>

<script>
import bimCheckbox from '@/components/form/bimCheckbox/bimCheckbox'
export default {
  name: 'FieldCheckbox',
  components: {
    bimCheckbox,
  },
  props: {
    value: Boolean,
    label: String,
    id: {
      type: String,
      default: () => Math.random().toString()
    }
  }
}
</script>

<style scoped lang="scss">

</style>
